const getProperty = () => {
  const property = localStorage.getItem("property")
    ? JSON.parse(localStorage.getItem("property"))
    : null;
  return property;
};

const InitialState = {
  property: getProperty(),
};

const PropertyReducer = (state = InitialState, action) => {
  if (action.type === "Save_Property") {
    const newState = {
      property: action.payload,
    };

    localStorage.setItem("property", JSON.stringify(action.payload));
    return newState;
  }

  //logout
  else if (action.type === "Remove_User") {
    localStorage.removeItem("property");
    const newState = {
      property: null,
    };
    return newState;
  }

  return state;
};

export default PropertyReducer;
